// import PnLCard from "./PnLCard";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faBars } from "@fortawesome/free-solid-svg-icons";
// import api from "../services/api";
// import { useAuth } from "../hooks/useAuth";

// const Header = ({ onToggleSidebar }) => {
//   const { logout } = useAuth();

//   const handleLogout = () => {
//     api.get("/auth/logout").then(() => {
//       logout();
//     });
//   };

//   return (
//     <>
//       <nav className="main-header navbar navbar-expand navbar-white navbar-light">
//         {/* Left navbar links */}
//         <ul className="navbar-nav">
//           <li className="nav-item">
//             <button
//               className="nav-link"
//               onClick={onToggleSidebar}
//               style={{ background: "none", border: "none", cursor: "pointer" }}
//             >
//               <FontAwesomeIcon icon={faBars} />
//             </button>
//           </li>
//         </ul>

//         {/* Right navbar links */}
//         <ul className="navbar-nav ml-auto">
//           <li className="nav-item">
//             <span className="nav-link">Welcome, User</span>
//           </li>
//           <li onClick={() => handleLogout}>Logout</li>
//         </ul>
//       </nav>
//       <PnLCard />
//     </>
//   );
// };

// export default Header;

import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Box,
  Menu,
  MenuItem,
  Avatar,
  Divider,
  ListItemIcon,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LogoutIcon from "@mui/icons-material/Logout";
import SecurityIcon from "@mui/icons-material/Security";
import { useAuth } from "../hooks/useAuth";
import api from "../services/api";
// import PnLCard from "./PnLCard";
import { green, red, blue } from "@mui/material/colors";
import { useState, useEffect, useRef, useContext } from "react";
import { fetchBalance } from "../services/tradeService";
import { AuthContext } from "../contexts/AuthContext";
import useWebSocket from "../hooks/useWebSocket";
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import SignalCellularOffIcon from '@mui/icons-material/SignalCellularOff';
import { usePortfolioStore } from "../store/usePortfolioStore";
import { useLivePrices } from "../hooks/useLivePrices";
import { formatPrice } from "../utils/utils";

type Props = {
  onToggleSidebar: () => void;
};

/** Module-level flag — survives StrictMode's unmount/remount cycle */
let tickerScriptLoaded = false;

/** Isolated component — mounts the TradingView script exactly once */
function TickerTape() {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el || tickerScriptLoaded) return;
    tickerScriptLoaded = true;

    const script = document.createElement('script');
    script.type = 'module';
    script.src = 'https://widgets.tradingview-widget.com/w/en/tv-ticker-tape.js';
    script.onload = () => {
      // Guard: only append if the container is still empty
      if (el.querySelector('tv-ticker-tape')) return;
      const tape = document.createElement('tv-ticker-tape');
      tape.setAttribute('symbols', 'CMCMARKETS:GOLD,IG:NASDAQ,BSE:SENSEX,CAPITALCOM:SPX500');
      tape.setAttribute('line-chart-type', 'Line');
      tape.setAttribute('item-size', 'compact');
      tape.setAttribute('show-hover', '');
      tape.setAttribute('theme', 'dark');
      el.appendChild(tape);
    };
    el.appendChild(script);

    // No cleanup — intentionally persist across StrictMode remounts
  }, []);

  return <Box ref={containerRef} height="52px" />;
}

export default function Header({ onToggleSidebar }: Props) {
  const { logout, user } = useAuth();
  const [balance, setBalance] = useState<any>(null);
  const authContext = useContext(AuthContext);
  const isAdmin = authContext?.isAdmin || false;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { connected } = useWebSocket();
  const { stats, fetchPortfolio, updateStats, isInitialized, holdings, positions } = usePortfolioStore();
  const { prices, getLivePrice } = useLivePrices();

  useEffect(() => {
    // Only fetch balance if Zerodha is linked
    if (authContext?.user?.isZerodhaLinked) {
      fetchBalance()
        .then((resp) => setBalance(resp.equity))
        .catch(console.error);

      if (!isInitialized) {
        fetchPortfolio();
      }
    }
  }, [isInitialized, authContext?.user?.isZerodhaLinked]);

  useEffect(() => {
    if (isInitialized) {
      const tokens = [
        ...holdings.map((h) => h.instrument_token),
        ...positions.map((p) => p.instrument_token),
      ].filter(t => t);
      if (tokens.length > 0) getLivePrice(tokens);
    }
  }, [isInitialized, holdings, positions]);

  useEffect(() => {
    // if (isAdmin) {
    updateStats(prices);
    // }
  }, [prices, updateStats]);

  const handleLogout = () => {
    api.post("/auth/logout").then(() => {
      logout();
    });
  };
  const pnl = 200000;
  return (
    <AppBar position="fixed" sx={{ zIndex: 1201, backgroundColor: "#1f2a40" }}>
      <TickerTape />
      <Toolbar>
        <IconButton edge="start" color="inherit" onClick={onToggleSidebar}>
          <MenuIcon />
        </IconButton>
        <Typography variant="h6" sx={{ flexGrow: 1, display: "flex", alignItems: "center", gap: 2 }}>
          {/* <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
            Algo Trading Bot
          </Typography> */}
          {/* {isAdmin && <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, opacity: 0.8 }}>
            {connected ? <SignalCellularAltIcon sx={{ fontSize: 16, color: green[400] }} /> : <SignalCellularOffIcon sx={{ fontSize: 16, color: red[400] }} />}
            <Typography sx={{ fontSize: '10px', color: connected ? green[400] : red[400] }}>
              {connected ? "LIVE" : "DISCONNECTED"}
            </Typography>
          </Box>} */}
        </Typography>
        <Box sx={{ display: "flex", gap: 3, paddingRight: "15px", alignItems: "center" }}>

          {!authContext?.user?.isZerodhaLinked ? (
            <Button
              variant="contained"
              color="warning"
              onClick={async () => {
                try {
                  const response = await api.get("/auth/zerodha-url");
                  if (response.data.url) {
                    window.location.href = response.data.url;
                  }
                } catch (err) {
                  console.error("Failed to get Zerodha authentication URL", err);
                }
              }}
              startIcon={<SecurityIcon />}
              sx={{
                borderRadius: "20px",
                fontWeight: 600,
                textTransform: "none",
                px: 2.5,
                py: 0.75,
                boxShadow: "0 4px 10px rgba(237, 108, 2, 0.3)",
                "&:hover": {
                  backgroundColor: "warning.dark",
                }
              }}
            >
              Authenticate Zerodha
            </Button>
          ) : (
            <>
              {isAdmin && (
                <>
                  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                    <Typography sx={{ fontSize: "10px", opacity: 0.7, lineHeight: 1 }}>Investment</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: "bold" }}>
                      {formatPrice(stats.totalInvestment, 0)}
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                    <Typography sx={{ fontSize: "10px", opacity: 0.7, lineHeight: 1 }}>Overall P&L</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: "bold", color: stats.overallPNL >= 0 ? green[400] : red[400] }}>
                      {formatPrice(stats.overallPNL, 0)}
                      <span style={{ fontSize: '10px', marginLeft: '4px' }}>
                        ({stats.overallPNLPercent.toFixed(1)}%)
                      </span>
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                    <Typography sx={{ fontSize: "10px", opacity: 0.7, lineHeight: 1 }}>Today P&L</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: "bold", color: stats.todayPNL >= 0 ? green[400] : red[400] }}>
                      {formatPrice(stats.todayPNL, 0)}
                    </Typography>
                  </Box>

                  <Box sx={{ width: "1px", height: "24px", bgcolor: "rgba(255,255,255,0.1)", mx: 1 }} />
                </>
              )}

              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                <Typography sx={{ fontSize: "10px", opacity: 0.7, lineHeight: 1 }}>Balance</Typography>
                <Typography sx={{ fontSize: "14px", fontWeight: "bold", color: blue[300] }}>
                  {formatPrice(balance?.available?.live_balance || 0, 0)}
                </Typography>
              </Box>
            </>
          )}

        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Button
            onClick={handleClick}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1.5,
              textTransform: 'none',
              color: 'inherit',
              padding: '6px 12px',
              borderRadius: '20px',
              transition: 'all 0.2s ease',
              backgroundColor: open ? 'rgba(255, 255, 255, 0.08)' : 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.08)',
              },
            }}
          >
            <Avatar
              sx={{
                width: 32,
                height: 32,
                fontSize: '14px',
                fontWeight: 'bold',
                backgroundImage: 'linear-gradient(135deg, #4f46e5 0%, #ec4899 100%)',
                color: '#fff',
                border: '1.5px solid rgba(255, 255, 255, 0.2)',
              }}
            >
              {(user?.name || 'U').charAt(0).toUpperCase()}
            </Avatar>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mr: 0.5 }}>
              <Typography sx={{ fontSize: '13px', fontWeight: 600, lineHeight: 1.2 }}>
                {user?.name || 'User'}
              </Typography>
              <Typography sx={{ fontSize: '10px', opacity: 0.6, lineHeight: 1 }}>
                {user?.role === 'admin' ? 'Admin' : 'Viewer'}
              </Typography>
            </Box>
            <KeyboardArrowDownIcon
              sx={{
                fontSize: 18,
                opacity: 0.7,
                transform: open ? 'rotate(180deg)' : 'none',
                transition: 'transform 0.2s ease',
              }}
            />
          </Button>

          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            slotProps={{
              paper: {
                sx: {
                  mt: 1,
                  backgroundColor: '#1f2a40',
                  color: '#fff',
                  border: '1px solid rgba(255, 255, 255, 0.08)',
                  boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.4), 0 8px 10px -6px rgba(0, 0, 0, 0.4)',
                  minWidth: 180,
                  '& .MuiMenuItem-root': {
                    fontSize: '13px',
                    padding: '10px 16px',
                    transition: 'all 0.15s ease',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 0.05)',
                    },
                  },
                },
              },
            }}
          >
            <Box sx={{ px: 2, py: 1.5, pointerEvents: 'none' }}>
              <Typography sx={{ fontSize: '13px', fontWeight: 600 }}>
                {user?.name || 'User'}
              </Typography>
              <Typography sx={{ fontSize: '11px', opacity: 0.5, wordBreak: 'break-all' }}>
                {user?.email || ''}
              </Typography>
            </Box>
            <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.08)' }} />
            <MenuItem onClick={handleLogout} sx={{ color: '#ff4d4f' }}>
              <ListItemIcon sx={{ color: '#ff4d4f', minWidth: '30px !important' }}>
                <LogoutIcon sx={{ fontSize: 18 }} />
              </ListItemIcon>
              Logout
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>

    </AppBar>
  );
}
